import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const d = {
  display: "block"
}, g = ({ size: t = 16, useVw: l, useRem: n, color: o, withColor: c, removeClassName: a, disableSSR: m, style: i, ...p }) => {
  const x = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ e.createElement(f, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-dongtai", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (n ? "rem" : "px"), height: l ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (n ? "rem" : "px"), className: a ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: a ? "" : "32px-å¨æ"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: a ? "" : "normal",
        clipRule: "evenodd",
        fillRule: "evenodd",
        fill: c ? r(o, 0, "#262933") : "#262933",
        datafollowfill: c ? r(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M22.32 10.872a.9.9 0 0 0-1.192-1.191l-7.563 3.437a.9.9 0 0 0-.447.447l-3.437 7.563a.9.9 0 0 0 1.192 1.191l7.562-3.437a.9.9 0 0 0 .447-.447l3.437-7.563Zm-10.007 8.816 2.304-5.07 5.07-2.306-2.304 5.07-5.07 2.305Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M16 3.1C8.876 3.1 3.1 8.876 3.1 16c0 7.124 5.776 12.9 12.9 12.9 7.125 0 12.9-5.776 12.9-12.9 0-7.124-5.775-12.9-12.9-12.9ZM4.9 16C4.9 9.87 9.87 4.9 16 4.9S27.1 9.87 27.1 16 22.13 27.1 16 27.1 4.9 22.13 4.9 16Z"
        }
      )
    )
  )));
}, h = g;
export {
  h as default
};
